import { ModelConstants } from '../model-constants';
import { IAttribute, IModel } from './../base/annotation';
import { Metamodel } from '../base/model';
import { LinkedService } from './linkedservice';
import { shellStringResources as stringResources } from '../../Resources/ShellStringResources';
import { AzureKeyVault } from './key-vault';
import { format } from '../../shared/utils/string.util';
import { validateAKVLinkedServiceReference } from '../../shared/utils/linkedservice-validation-util';

@Metamodel.model({
    name: ModelConstants.ftpServerLinkedService,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.FtpServer_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.FtpServer_DisplayText)
    ]
})
export class FtpServerLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    public static readonly HOST: IAttribute;
    public static readonly PORT: IAttribute;
    public static readonly USER_NAME: IAttribute;
    public static readonly PASSWORD: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_Host,
        association: 'HOST',
        templatable: true
    })
    public host?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Port,
        association: 'PORT',
        templatable: true
    })
    public port?: number = 21;

    @Metamodel.attribute({
        display: stringResources.ModelName_EnableSSL
    })
    public enableSsl?: boolean = true;

    @Metamodel.attribute({
        display: stringResources.ModelName_EnableServerCertificateValidation
    })
    public enableServerCertificateValidation?: boolean = true;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName,
        association: 'USER_NAME',
        templatable: true
    })
    public userName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedServiceReference
        },
        association: 'PASSWORD',
        templatable: true,
        accepts: ['String']
    })
    public password?: string | AzureKeyVault;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
